module.exports = __webpack_public_path__ + "img/loading-user.727d1dc7.png";